module.exports = __webpack_public_path__ + "static/media/success_failed.49aaf2c7.png";